import type { FC } from 'react'
import { Box, CircularProgress, CircularProgressProps, SxProps, Theme } from '@mui/material'

const indicatorStyles = ({ isFullHeight }: { isFullHeight: boolean }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: isFullHeight ? '100vh' : undefined,
})

type LoadingIndicatorProps = CircularProgressProps & {
  isFullHeight?: boolean
}

export const LoadingIndicator: FC<LoadingIndicatorProps> = ({
  isFullHeight = true,
  color = 'secondary',
  sx,
  ...rest
}) => (
  <Box
    sx={[indicatorStyles({ isFullHeight }), sx].filter(Boolean) as SxProps<Theme>}
    data-test="loading"
    data-testid="loading"
  >
    <CircularProgress color={color} {...rest} />
  </Box>
)
